// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1MCw8","productName":"Table_productName__1S5LE"};